/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

// Import custom modules
import App from './modules/app.js';

import initproductCarousel from './sections/our_products';
import initEventCarousels from './sections/events_carousel';
import initBanners from './sections/banner';
import accordion from './sections/accordion';
import instagramCarousel from './modules/instagramCarousel';
import initEventPage from './modules/eventsArchive';
import Search from './modules/search';
import 'bootstrap';
import $ from 'jquery';
import AjaxPostsLoader from './modules/ajaxPostsLoader';

// Initialize your components on DOM Ready.
document.addEventListener('DOMContentLoaded', () => {
  initEventCarousels();
  initBanners();
  instagramCarousel();
  initEventPage();
  initproductCarousel();
  new Search();

  $('p:empty').remove();
  $('ul.nav__list').removeClass('nav__item');
  $('ul.nav__list > li > ul').addClass('second-level');
  $('ul.nav__list > li > ul > li ul').addClass('dropdown animated');
  $('ul.nav__list .sub-menu').parent().find('> a')
    .prepend('<span class="nav__arrow"></div>');

  $('.header__menu_icon').on('click', function() {
    $(this).toggleClass('expand');
    $('body').toggleClass('nav-open');
  });

  $('.nav__arrow').on('click', function(e) {
    e.preventDefault();
    $(this).parent().parent().find('> .sub-menu').addClass('open')
      .parents('.sub-menu').addClass('open-parent').removeClass('open');
    $(this).parents('.header__navigation_mobi').addClass('open-parent');
    updateBackButtonText(this);
  });

  $('.sub-menu').each(function(i) {
    var str,
      getLinkTitle = $(this).parent().find(' > a').text();

    if ($(window).width() > 1200) {
      // only show title on first level
      if($(this).parents('.second-level').length) {
        // str = '<li><a class="nav__title" href="#" >&nbsp;</a></li>';
        return true;
      }
      else {
        str = '<li><a class="nav__title" href="#" >' +
        getLinkTitle +
        '</a></li>';
      }
    }
    else {
      str = '<li class="back__button" ><a class="menu-back__link" href="#" >' +
        'Gå tillbaka' +
        '</a></li>';
    }
    $(this).prepend(str);

  });


  $(window).resize(function(){
    navHeight();
  });

  function navHeight(){
    if($(window).width() < 768){
      const getHeight = $('.header__navigation_mobi ').outerHeight();
      $('.sub-menu').outerHeight(getHeight);
    }
  }

  navHeight();


  function updateBackButtonText(selector) {
    var text = $(selector).parent().text();
    $(selector).parent().parent().find('.menu-back__link').text(text);
  }

  $('.menu-back__link').on('click', function(e) {
    e.preventDefault();
    $(this).parent().parent('ul.sub-menu').removeClass('open')
      .parents('.sub-menu').removeClass('open-parent').addClass('open');
    var getClassName = $(this).parent().parent().attr('class').split(' ')[ 1 ];
    if (getClassName === 'second-level') {
      $(this).parents('.header__navigation_mobi').removeClass('open-parent');
    }
  });

  const currentPage = $('.product-nav [aria-current="page"]').text();
  $('.mobile-selectric__label')
    .text(currentPage)
    .on('click', function(e) {
      e.stopPropagation();
      $('.product-nav').toggleClass('product-nav--open')
        .parent().toggleClass('mobile-selectric-open');
      $('.product__overlay').fadeToggle();
    });

  $('body').on('click', function() {
    $('.product-nav').removeClass('product-nav--open')
      .parent().toggleClass('mobile-selectric-open');
    $('.product__overlay').fadeOut();
  });

  $('#menu-recipes-menu li a').on('click', function() {
    var text = $(this).text();
    $('.mobile-selectric__label').text(text);
    $('#menu-recipes-menu li').removeClass('current-menu-item');
    $(this).parent().addClass('current-menu-item');
  });

  $('.breadcrumb_last').parent('span').addClass('breadcrumb-item--last');


  $('#wppb-login-wrap p, #wppb-register-user li').each(function(){
    const label = $(this).find('label').text();
    $(this).find('input').attr('placeholder', label);
  });

  $('#register').val('Register');

  $('[data-ajax-posts-loader]').each(function() {
    new AjaxPostsLoader(this);
  });

  $(document).on( 'click', 'button.plus, button.minus', function() {
    
      var qty = $( this ).parent( '.quantity' ).find( '.qty' );
      var val = parseFloat(qty.val());
      var max = parseFloat(qty.attr( 'max' ));
      var min = parseFloat(qty.attr( 'min' ));
      var step = parseFloat(qty.attr( 'step' ));

      if ( $( this ).is( '.plus' ) ) {
          if ( max && ( max <= val ) ) {
            qty.val( max ).change();
          } else {
            qty.val( val + step ).change();
          }
      } else {
          if ( min && ( min >= val ) ) {
            qty.val( min ).change();
          } else if ( val > 1 ) {
            qty.val( val - step ).change();
          }
      }
      var updatedval = parseFloat(qty.val());

      if($( this ).parent().parent().siblings('.category_addto').length){
        var link = $( this ).parent().parent().siblings('.category_addto').find('a').attr('href');
        var linkpart = link.split('&');
        var newlink = linkpart[0]+'&quantity='+updatedval;
        $( this ).parent().parent().siblings('.category_addto').find('a').attr('href',newlink);
      }

      if($("button[name='update_cart']").length){
        $("button[name='update_cart']").attr("disabled",false);
      }
      
  });

  class AgeVerify {
    constructor() {
      this.$ = jQuery;
      this.popup = document.querySelector('.popup');
      const self = this;

      if(this.popup){
        if(
          this.getCookie('age_approved') !== 'verified' ||
          this.getCookie('age_approved') == 'undefined'
        ) {
          this.popup.style.display = 'block';
        }
        else {
          this.popup.style.display = 'none';
        }
      }


      $('.js-popup__entire').on('click', function(e){
        e.preventDefault();

        $('.popup').fadeOut(function(){
          self.setCookie('age_approved', 'verified', 5);
        });
      });

      $('.js-popup__cancel').on('click', function(){
        self.setCookie('age_approved', 'verified', 5);
        this.popup.style.display = 'none';
      });
    }

    setCookie(name, value, days) {
      var expires = '';
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '')  + expires + '; path=/';
    }

    getCookie(name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
  }

  new AgeVerify();
});
